import { render } from "./SupplierMergeModal.vue?vue&type=template&id=99808a9e&scoped=true"
import script from "./SupplierMergeModal.vue?vue&type=script&lang=js"
export * from "./SupplierMergeModal.vue?vue&type=script&lang=js"

import "./SupplierMergeModal.vue?vue&type=style&index=0&id=99808a9e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99808a9e"]])

export default __exports__